import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import qs from 'qs';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { IProductProfileResponse } from 'pages/supplier-intelligence/utils/types';
import type { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/supplier-intelligence/products/profile';

type TData = IProductProfileResponse;
type TError = AxiosError;
type TQueryKey = [string, { productIds: number[]; supplierId?: number }];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetSiProductProfileApi(
  productIds: number[],
  supplierId?: number,
  options?: Options
): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const params: any = { productIds, supplierId };
      const { data } = await http.get(endpoint, {
        params,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
      });
      return data?.data ?? data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useQueryWrapper([endpoint, { productIds, supplierId }], queryFn, {
    enabled: isLoggedIn && productIds.length > 0,
    ...options,
  });
}
